import { render, staticRenderFns } from "./purchase_list.vue?vue&type=template&id=16aa9d74&scoped=true"
import script from "./purchase_list.vue?vue&type=script&lang=js"
export * from "./purchase_list.vue?vue&type=script&lang=js"
import style0 from "./purchase_list.vue?vue&type=style&index=0&id=16aa9d74&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16aa9d74",
  null
  
)

export default component.exports